import { Component, OnInit, Input } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

import { sliderOpt } from 'src/app/shared/data';

@Component( {
	selector: 'related-products-one',
	templateUrl: './related-products-one.component.html',
	styleUrls: [ './related-products-one.component.scss' ]
} )


export class RelatedProductsOneComponent implements OnInit {

	@Input() products = [];
	@Input() loaded = false;

	customOptions: OwlOptions;

	

	constructor () { }

	ngOnInit (): void {
		this.customOptions = {
			//...sliderOpt,
			autoplay:true,			
			autoplaySpeed:200,
			loop: false,
			mouseDrag: true,
			touchDrag: true,
			pullDrag: true,
			dots: true,
			navSpeed: 800,			
			navText: ['<', '>'],		//	&#8249    &#8250;									
			nav: false,	
			margin:15,
			autoplayHoverPause:true,
			autoHeight:true,
			center:true,
			skip_validateItems: true,									
		}
	
		this.loaded=true;
	}
}
